module.exports = __webpack_public_path__ + "img/banner.2c841f7b.jpg";